import { IbanInvoiceGetByFilterQuery } from "api";
import { InvoiceFiltersState } from "pages/Invoices/Main/InvoiceFilters/types";

export const formatInvoiceFilters = (
  filters?: InvoiceFiltersState
): Partial<IbanInvoiceGetByFilterQuery> => {
  const { invoiceDateRange, expirationDateRange, ...rest } = filters || {};

  const invoiceFrom = invoiceDateRange?.range?.from;
  const invoiceTo = invoiceDateRange?.range?.to;

  const expirationFrom = expirationDateRange?.range?.from;
  const expirationTo = expirationDateRange?.range?.to;
  const noExpiration = expirationDateRange?.noExpiration;

  return {
    ...rest,
    ...(expirationFrom || expirationTo || typeof noExpiration === "boolean"
      ? {
          expirationDateRange: {
            ...(expirationFrom || expirationTo
              ? {
                  dateRange: {
                    from: expirationFrom?.toISOString(),
                    to: expirationTo?.toISOString(),
                  },
                }
              : {}),
            ...(typeof noExpiration === "boolean" ? { noExpiration } : {}),
          },
        }
      : {}),

    ...(invoiceFrom && invoiceTo
      ? {
          invoiceDateRange: {
            from: invoiceFrom.toISOString(),
            to: invoiceTo.toISOString(),
          },
        }
      : {}),
  };
};
